import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import Axios from "axios";
import Vconsole from 'vconsole'
import { clear } from '@/utils/common.js'
// import VueAxios from "vue-axios";
// 适配方案
import "lib-flexible/flexible.js";
import './assets/css/iconfont/iconfont.css'


import VueLazyload from "vue-lazyload";
import waterfall from 'vue-waterfall2';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
Vue.use(waterfall);
Vue.use(VueLazyload);
// let vConsole = new Vconsole()
// Vue.use(vConsole)
// 引入 vant-ui
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);


// 公共样式
import "./assets/css/common.less";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false;

const IS_TEST = false;


//系统错误捕获
const errorHandler = (error, vm) => {
  window.console.error(error);
  window.alert(error);
  window.console.log(vm.$route.name);
  if (typeof error == "object") {
    error = JSON.stringify(error);
  }
  let user = localStorage.getItem("userinfo");

  let params = {
    var_1: "name:" + vm.$route.name,
    text_1: error,
    text_2: window.navigator.userAgent
  }
  if (user) {
    params.var_2 = user;
  }
  window.axios.post("/log", params);
};
window.addEventListener('pagehide', () => {
  clear()
  localStorage.removeItem('img')
});


Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = function (error) {
  return errorHandler(error, this);
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");